import axios from "axios"

export const getAddressByZipCode = async (zipCode: string) =>
	await axios.get(`${process.env.REACT_APP_VIACEP_API}/${zipCode}/json/`)
